import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';
import DataGrid, {
  Column,
  Paging,
  Lookup,
  RequiredRule
} from 'devextreme-react/data-grid';
import { ColorBox } from 'devextreme-react/color-box';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
//import { useAgents } from "../context/AgentContext";
import { useNavigate } from "react-router-dom";

const CVPreference = () => {
  const [preferences, setPreferences] = useState([]);
  const [templates, setTemplates] = useState([]);
  //const agents = useAgents() || [];
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const gridRef = useRef(null);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [prefResponse, templateResponse] = await Promise.all([
          api.get("/CVPreferences"),
          api.get("/CVTemplates")
        ]);
    
        setPreferences(prefResponse.data || []);
        setTemplates(templateResponse.data || []);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle form submission
  const handleSubmit = async () => {
    if (!gridRef.current) return;
    
    try {
        const dataGrid = gridRef.current.instance;
        const data = dataGrid.option('dataSource');
        
        // Transform data to match your backend model
        const payload = data.map(item => ({
            agentID: item.agentID,
            agentName: item.agentName,
            templateName: item.templateName,
            cvColor: item.cvColor,
            cvFontColor: item.cvFontColor
            // Add other required fields that match your CVPreference model
        }));
        
        console.log('Submitting data:', payload);
        
        const response = await api.post('/CVPreferences', payload);

        if (response.status >= 200 && response.status < 300) {
            navigate("/defaultsettings/create");
        } else {
            throw new Error(`API returned status ${response.status}`);
        }
    } catch (error) {
        console.error('Error saving data:', error);
        // Add user feedback here
        alert('Failed to save preferences. Please check the data and try again.');
    }
};

  // Update preferences when changes occur
  const handleDataChange = (e) => {
    if (e.dataField && e.key) {
      const newData = [...preferences];
      const index = newData.findIndex(item => item.agentID === e.key);
      if (index >= 0) {
        newData[index][e.dataField] = e.value;
        setPreferences(newData);
      }
    }
  };

  // Custom editor for color columns (always visible)
  const colorCellRender = ({ data, column }) => {
    return (
      <ColorBox
        value={data[column.dataField]}
        onValueChanged={(e) =>
          handleDataChange({
            dataField: column.dataField,
            value: e.value,
            key: data.agentID,
          })
        }
        editAlphaChannel={true}
        width="100%"
        dropDownOptions={{
          //height: 250, 
        }}
      />
    );
  };

  // Custom editor for template dropdown (always visible)
  // Custom editor for template dropdown (always visible)

// Custom editor for template dropdown (always visible)
const templateCellRender = (cellData) => {
  return (
    <SelectBox
      value={cellData.data.templateName}  // Access the current row's templateName
      displayExpr="templateName"
      valueExpr="templateName"
      dataSource={templates}
      onValueChanged={(e) => {
        handleDataChange({
          dataField: 'templateName',
          value: e.value,
          key: cellData.data.agentID
        });
      }}
      width="100%"
      itemRender={(item) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img 
            src={item.imageUrl.startsWith('~') ? item.imageUrl.substring(1) : item.imageUrl} 
            alt={item.templateName}
            style={{ width: 220, height: 340, marginRight: 10 }}
          />
          <span>{item.templateName}</span>
        </div>
      )}
    />
  );
};

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
<div className="container mt-4" style={{ maxWidth: "1100px" }}>
      <h5 className="es-label-title">MANAGE AGENTS CV PREFERENCE </h5>
      <div className="card p-3">
      <DataGrid
        dataSource={preferences}
        keyExpr="agentID"
        showBorders={true}
        ref={gridRef}
        repaintChangesOnly={true}
      >
        <Paging enabled={true} pageSize={10} />

        {/* Agent Column (read-only) */}
        <Column
          dataField="agentName"
          caption="Agent"
          //cellRender={agentCellRender}
          allowEditing={false}
        />

        {/* Template Name Column (always showing dropdown) */}
        <Column
          dataField="templateName"
          caption="Template"
          cellRender={templateCellRender}
        >
          <RequiredRule />
          <Lookup
            dataSource={templates}
            valueExpr="templateName"
            displayExpr="templateName"
            itemRender={(item) => (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img 
                  src={item.imageUrl} 
                  alt={item.templateName}
                  style={{ width: 30, height: 30, marginRight: 10 }}
                />
                <span>{item.templateName}</span>
              </div>
            )}
          />
        </Column>

        {/* CV Color Column (always showing color picker) */}
        <Column
          dataField="cvColor"
          caption="CV Color"
          cellRender={colorCellRender}
        >
          <RequiredRule />
        </Column>

        {/* CV Font Color Column (always showing color picker) */}
        <Column
          dataField="cvFontColor"
          caption="Font Color"
          cellRender={colorCellRender}
        >
          <RequiredRule />
        </Column>
      </DataGrid>
      
      <div style={{ marginTop: '20px', textAlign: 'right' }}>
        <Button
          text="Submit"
          type="success"
          onClick={handleSubmit}
          disabled={loading}
        />
      </div>

      </div>
    </div>
  );
};

export default CVPreference;